import { motion } from "framer-motion";

export default function SectionTitle({ eyebrow, title, highlight, align = "center", text }) {
  return (
    <motion.div
      className={`section-title ${align === "left" ? "section-title-left" : ""}`}
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{ duration: 0.5 }}
    >
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>
        {title} {highlight && <span>{highlight}</span>}
      </h2>
      {text && <p>{text}</p>}
      <div className="title-rule" />
    </motion.div>
  );
}
